export const isCompanyDeactivated = user => {
  return user?.company?.deleted_at
}

export default {
  isCompanyDeactivated,
}
